<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <h3 class="titles">确认预约信息</h3>
    <div class="content">
      <div class="top-center">
        <p>
          参观日期：
          <span class="day">{{confirmData.day}}</span>
        </p>
      </div>
      <div class="list">
        <h3>身份信息</h3>
        <div class="list-wrapper">
          <div class="item" v-for="(item,index) in confirmData.list" :key="index">
            <div class="title">
              {{item.toi_username}}
              <span>{{item.pt_name}}</span>
            </div>
            <p>{{item.cardName}} {{item.toi_card_num}}</p>
            <p>
              {{item.ticket_name}}
              <span class="num">
                ￥
                <span>{{Number(item.price).toFixed(2)}}</span>
              </span>
            </p>
            <p v-if="item.ticket_name2">
              {{item.ticket_name2}}
              <span class="num">
                ￥
                <span>{{Number(item.price2).toFixed(2)}}</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <p class="total">
        总计：
        <span>
          ￥
          <span class="num">{{Number(confirmData.total).toFixed(2)}}</span>
        </span>
      </p>
    </div>
    <div class="btn-group">
      <div class="back-btn" @click="goBack">上一步</div>
      <div class="ok" @click="createOrder">去支付</div>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="mask" v-if="printF">
      <div class="mask-content">
        <div class="icon2"></div>
        <p>出票中，请稍后……</p>
      </div>
    </div>
    <div class="footer">
      <div class="footer-content">
        <p>
          <!-- 设备ID：{{deviceId}} -->
          <span class="tel">
            客服电话
            <span>25650850 25650860</span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { setInterval, clearInterval } from 'timers'
  import U from '../commom'

  export default {
    name: 'HelloWorld',
    data () {
      return {
        warn: '',
        deviceId: localStorage.deviceNum || '123456789',
        time: '',
        today: '',
        timer: '',
        day: '',
        post: '',
        confirmData: '',
        printF: false,
        strReturn: '',
        detail: '',
        ticket_list: [],
        createF: false,
        printFs: true
      }
    },
    created () {
      this.post = JSON.parse(localStorage.post)
      this.confirmData = JSON.parse(localStorage.confirmData)
    },
    mounted () {
      this.getDay()
      if (this.timer == '') {
        this.timer = setInterval(() => {
          this.getDay()
        }, 10000)
      }
    },
    destroyed () {
      clearInterval(this.timer)
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      getDay () {
        var day = new Date()
        var hours = day.getHours()
        var year = day.getFullYear()
        hours = hours < 10 ? '0' + hours : hours
        var min = day.getMinutes()
        min = min < 10 ? '0' + min : min
        var month = day.getMonth() + 1
        var days = day.getDate()
        var week = day.getDay()
        var strWeek = ''
        switch (week) {
          case 0:
            strWeek = '星期日'
            break
          case 1:
            strWeek = '星期一'
            break
          case 2:
            strWeek = '星期二'
            break
          case 3:
            strWeek = '星期三'
            break
          case 4:
            strWeek = '星期四'
            break
          case 5:
            strWeek = '星期五'
            break
          case 6:
            strWeek = '星期六'
            break
        }
        this.time = hours + ':' + min
        this.today = month + '月' + days + '日 ' + strWeek
        this.day = year + '-' + month + '-' + days
      },

      createOrder () {
        if (!this.createF) {
          this.createF = true
          this.$api
            .createdTicketOrder(
              this.post.td_tp_id,
              this.post.pt_id,
              this.post.toi_username,
              this.post.toi_card_num,
              this.post.toi_cardtype_id,
              this.post.is_children,
              this.post.is_parent,
              this.post.td_tp_ids
            )
            .then(res => {
              if (res.status == 1) {
                if (res.data.order_status == 3) {
                  // 获取订单信息
                  this.ticket_print(res.data.torder_id)
                  this.order_id = res.data.torder_id
                  return false
                }
                this.$router.push({
                  path: '/pay',
                  query: {
                    id: res.data.torder_id
                  }
                })
              } else {
                this.warn = res.msg
                setTimeout(() => {
                  this.warn = ''
                }, 1500)
                return false
              }
            })
        }
      },
      ticket_print (id) {
        this.$api.TicketInfo(id).then(res => {
          this.detail = res.data
          this.ticket_list = res.data.item
          this.titem_id = ''
          this.ticket_list.map((item, index) => {
            if (index == 0) {
              this.titem_id = item.tickets[0].titem_id
            } else {
              this.titem_id += ',' + item.tickets[0].titem_id
            }
          })
          this.print_ticket()
        })
      },
      print_ticket () {
        if (this.printFs) {
          this.printFs = false
          this.$api.print_ticket(this.titem_id).then(ress => {
            var list = ress.data
            list.map((item, index) => {
              if (index == 0) {
                this.strReturn =
                  item.ticket_name +
                  ',' +
                  item.ticket_type +
                  // "," +
                  // item.toi_username +
                  ',' +
                  item.t_date +
                  ',' +
                  item.time_period +
                  ',' +
                  item.toi_sn_encode +
                  ',' +
                  item.order_sn +
                  ';'
              } else {
                this.strReturn +=
                  item.ticket_name +
                  ',' +
                  item.ticket_type +
                  // "," +
                  // item.toi_username +
                  ',' +
                  item.t_date +
                  ',' +
                  item.time_period +
                  ',' +
                  item.toi_sn_encode +
                  ',' +
                  item.order_sn +
                  ';'
              }
            })
            if (ress.status == 1) {
              this.wran = ''
              var obj = jsObj.getPageStatus()
              var pageNum = obj.split(',')[1]
              if (Number(pageNum) >= list.length) {
                this.printF = true
                jsObj.PrintSellTicket('1', this.strReturn)
                var obj = jsObj.getPageStatus()
                var num2 = Number(obj.split(',')[1])
                var num3 = Number(obj.split(',')[2])
                var type = num2 < num3 ? 1 : 2
                setTimeout(() => {
                  this.$router.push({
                    path: '/ticket_success',
                    query: {
                      order_id: this.order_id,
                      type: type
                    }
                  })
                }, 2000)
              } else {
                this.warn = '纸张不足，请联系客服人员'
                var timers = setTimeout(() => {
                  this.warn = ''
                  this.$router.replace('/nopage')
                }, 2000)
                clearTimeout(timers)
              }
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .container {
    width: 100%;
    min-height: 1920px;
    background: #f0f0f0;
    overflow: hidden;
    position: relative;
    padding-bottom: 165px;

    .top {
      padding: 30px 32px;
      color: #4d4d4d;
      font-size: 25px;

      h3 {
        font-size: 70px;
        margin: 0;
      }
    }

    .titles {
      font-size: 60px;
      letter-spacing: 3px;
      color: #0c5193;
      text-align: left;
      width: 100%;
      padding: 90px 50px 30px;
    }
  }

  .btn-group {
    margin: 40px auto 0;
    width: 960px;

    .back-btn {
      display: inline-block;
      width: 330px;
      height: 98px;
      border: 1px solid #b95020;
      color: #b95020;
      border-radius: 49px;
      font-size: 30px;
      line-height: 96px;
      text-align: center;
      cursor: pointer;
      margin-right: 57px;
      margin-left: 40px;
    }

    .ok {
      width: 488px;
      height: 98px;
      line-height: 98px;
      background: #b95020;
      color: #fff;
      font-size: 30px;
      border-radius: 49px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
    }
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    z-index: 999;
    transition: all ease-in-out 300ms;

    .mask-content {
      width: 600px;
      height: 384px;
      background: #fff;
      border-radius: 6px;
      padding: 65px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .icon {
        width: 102px;
        height: 102px;
        background: url(.././assets/icon.png) no-repeat;
        background-size: cover;
        margin: 0 auto 80px;
      }

      .icon2 {
        width: 97px;
        height: 104px;
        background: url(.././assets/print.png) no-repeat;
        background-size: cover;
        margin: 0 auto 80px;
      }

      p {
        color: #5c5c5c;
        font-size: 30px;
        text-align: center;
      }
    }
  }

  .content {
    width: 1002px;
    margin: 0 auto;
    min-height: 764px;
    position: relative;

    .top-center {
      font-size: 34px;
      margin-bottom: 24px;
      padding: 40px;
      line-height: 50px;
      background: #fff;
      border-radius: 4px;

      .p {
        font-size: 40px;
        color: #474747;
        font-weight: 600;
        margin-top: -20px;

        .type {
          width: 160px;
          height: 50px;
          color: #474747;
          padding-left: 35px;
          position: relative;
          display: inline-block;
          margin-right: 64px;
          margin-top: 20px;
          cursor: pointer;

          &:after {
            content: "";
            width: 20px;
            height: 20px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            border: 3px solid #ce6b3d;
            left: 3px;
            border-radius: 50%;
            z-index: 1;
          }

          &.active:before {
            content: "";
            width: 15px;
            height: 15px;
            background: #ce6b3d;
            position: absolute;
            top: 50%;
            left: 8.25px;
            transform: translateY(-50%);
            z-index: 2;
            border-radius: 7.5px;
          }
        }
      }

      p {
        font-size: 40px;
        color: #474747;
        font-weight: 600;

        span {
          color: #005192;
        }
      }

      .top-list {
        overflow: hidden;

        .item-list {
          width: 280px;
          height: 80px;
          text-align: center;
        }
      }

      h3 {
        font-size: 40px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding-bottom: 30px;
      }

      .list {
        padding: 30px 0;
        border-bottom: 2px solid rgba(0, 0, 0, 0.2);

        &:last-child {
          border-bottom: 0 none;
        }

        .title {
          font-size: 40px;
          color: #000;
          font-weight: 600;
          overflow: hidden;
          vertical-align: middle;
          margin-bottom: 18px;
          padding-left: 60px;
          position: relative;

          &.disable {
            opacity: 0.45;
            cursor: none;
          }

          &:after {
            content: "";
            width: 22px;
            height: 22px;
            position: absolute;
            top: 50%;
            left: 2px;
            transform: translateY(-50%);
            border: 3px solid #ce6b3d;
            border-radius: 50%;
          }

          &.active:before {
            content: "";
            width: 15px;
            height: 15px;
            background: #ce6b3d;
            position: absolute;
            top: 50%;
            left: 8.25px;
            transform: translateY(-50%);
            z-index: 2;
            border-radius: 7.5px;
          }

          span {
            float: right;
            color: #e8593e;
            font-size: 20px;
            line-height: 50px;

            .num {
              font-size: 40px;
            }
          }
        }

        .des {
          font-size: 30px;
          color: #808080;
        }

        .options {
          padding: 30px 0 0px 30px;

          .title {
            padding: 0;

            .iconfont {
              font-size: 34px;
              display: inline-block;
              border: 1px solid #ce6b3d;
              border-radius: 4px;
              width: 36px;
              height: 36px;
              margin-right: 5px;
              text-align: center;
              line-height: 36px;
              color: #ce6b3d;
              float: none;
              vertical-align: middle;
            }
          }

          .title:after,
          .title::before {
            display: none;
          }
        }
      }
    }

    .list {
      background: #fff;
      border-radius: 4px;

      h3 {
        font-size: 40px;
        color: #000;
        padding: 40px 40px 30px;
      }

      .list-wrapper {
        padding: 0 50px;
        position: relative;
        border-top: 1px dashed #f0f0f0;

        &:after {
          content: "";
          width: 30px;
          height: 60px;
          border: 1px solid #f0f0f0;
          background: #f0f0f0;
          border-left: 0 none;
          border-radius: 0 30px 30px 0;
          position: absolute;
          top: -34px;
          left: -2px;
          z-index: 3;
        }

        &:before {
          content: "";
          width: 30px;
          height: 60px;
          border: 1px solid #f0f0f0;
          background: #f0f0f0;
          border-right: 0 none;
          border-radius: 30px 0 0 30px;
          position: absolute;
          top: -34px;
          right: -2px;
          z-index: 3;
        }

        .item {
          padding: 40px 0;
          border-bottom: 1px solid #b5b5b5;

          .title {
            color: #353535;
            font-size: 40px;
            font-weight: 600;
            margin-bottom: 32px;

            span {
              display: inline-block;
              color: #8d8d8d;
              font-size: 30px;
              font-weight: 400;
            }
          }

          p {
            color: #353535;
            font-size: 34px;
            margin-bottom: 30px;
            overflow: hidden;

            &:last-child {
              margin-bottom: 0;
            }

            .num {
              color: #e8593e;
              float: right;
              font-size: 24px;
              vertical-align: middle;
              line-height: 40px;

              span {
                font-size: 40px;
                font-weight: 600;
                line-height: 40px;
              }
            }
          }

          &:last-child {
            border: 0 none;
          }

          .from-control {
            font-size: 40px;
          }

          input {
            border: 0 none;
            outline: 0 none;
            font-size: 40px;
            line-height: 40px;
          }

          select {
            /*很关键：将默认的select选择框样式清除*/
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;

            /*在选择框的最右侧中间显示小箭头图片*/
            background: url(".././assets/arrow.png") no-repeat scroll right center transparent;

            /*为下拉小箭头留出一点位置，避免被文字覆盖*/
            padding-right: 14px;
            // background: #fff;
            font-size: 40px;
            outline: 0 none;
            border: 0 none;
            line-height: 50px;
            height: 50px;
            background-size: 5%;
            width: 690px;
          }

          option {
            border: none;
            outline: none;
            /*很关键：将默认的select选择框样式清除*/
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            /*将背景改为红色*/
            background: #fff;
            /*加padding防止文字覆盖*/
            padding-right: 0.14rem;
          }
        }
      }
    }
  }

  .bottom {
    margin: 52px auto;
    width: 850px;

    p {
      font-size: 35px;
      color: #353535;
      margin-bottom: 30px;
      overflow: hidden;

      span {
        float: right;
        display: inline-block;
        font-size: 24px;
        color: #e8593e;
        line-height: 34px;

        .num {
          font-size: 34px;
          font-weight: 600;
        }
      }

      &.total {
        font-size: 40px;
        text-align: right;
        line-height: 40px;

        span {
          line-height: 40px;
        }
      }
    }
  }

  .ok {
    width: 670px;
    height: 98px;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 3px;
    color: #fff;
    background: rgba(185, 80, 32, 1);
    border-radius: 49px;
    margin: 50px auto;
    cursor: pointer;
  }

  .back-btn {
    width: 670px;
    height: 98px;
    background: rgba(0, 81, 146, 0);
    border: 2px solid rgba(185, 80, 32, 1);
    border-radius: 49px;
    line-height: 98px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 3px;
    color: rgba(185, 80, 32, 1);
    margin: 0 auto;
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 24px;
    width: 100%;

    .footer-content {
      padding: 60px;
    }

    p {
      color: #5a5a5a;
      font-size: 20px;
      overflow: hidden;
      vertical-align: middle;

      .tel {
        float: right;
        color: #1c78f7;
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;

        span {
          margin-left: 10px;
          font-size: 34px;
          font-weight: 800;
          vertical-align: middle;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Ticket_confirm.vue